import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { ErgebnisComponent } from './ergebnis/ergebnis.component';
import { SucheComponent } from './suche/suche.component';
import { SessionGuard } from '../session/session.guard';

const ergebnisRoutes: Routes = [
  { path: 'kvNummerSuche', component: SucheComponent, canActivate: [SessionGuard] },
  { path: 'befreiungErgebnis', component: ErgebnisComponent, canActivate: [SessionGuard]}
];

@NgModule({
  imports: [RouterModule.forChild(ergebnisRoutes)],
  exports: [RouterModule],
  providers: []
})

export class BefreiungRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/befreiung/befreiung-routing.module.ts